<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/litenghui/production/report/details/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline"> </el-form>
      </template>
      <template #caozuo="scope">
        <el-button type="text" @click="yt.showEditDialog('mingxi', scope.row, '1300px')">{{ $t('mingxi') }}</el-button>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="data.no" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <label-details :reportData="data" :detailData="yt.editObj" v-if="yt.isShowEditDialog" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LabelDetails from '../label_details/index.vue';

export default {
  name: 'ReportDetails',
  components: {
    LabelDetails
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      columns: [
        {
          label: 'xuhao',
          prop: 'sn'
        },
        {
          label: 'shengchangongdanhao',
          prop: 'woNo'
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name'
        },
        {
          label: 'wangongshuliang',
          prop: 'finishQty'
        },
        {
          label: 'picihao',
          prop: 'batchNo'
        },
        {
          label: 'zuoyeyuan',
          prop: 'customOperator'
        },
        {
          label: 'caozuo',
          type: 'slot'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.productionReportId = this.data.id;
      this.yt.get(1);
    }, 300);
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.dialog-scroller {
  max-height: 600px;
  overflow-y: auto;
}

.el-table {
  margin: 20px;
  border-radius: 4px;

  ::v-deep .el-table__header-wrapper {
    th {
      background-color: #f5f7fa;
      color: #606266;
      font-weight: 500;
      padding: 12px 0;
    }
  }

  ::v-deep .el-table__body-wrapper {
    td {
      padding: 12px 0;
    }
  }
}
</style>
